var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('dash',{attrs:{"icon":"fa fa-file-text-o","titulo":"SERVIÇOS"},nativeOn:{"click":function($event){return _vm.toComprometimentos()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }